// ── TrainingDiscord.jsx ───────────────────────────────────────────────────────
// FIXES:
//  - Removed backdrop-filter on discord card (huge compositor cost)
//  - shimmer-bar uses will-change: left
//  - discord-card hover uses will-change: transform
//  - tp-discord-actions-row stacks on mobile (handled via tokens CSS)
//  - discord-grid gap reduced on tablet
import { DiscordIcon } from "./TrainingShared";
import { DISCORD_CHANNELS } from "./data/trainingData";

export const DISCORD_CSS = `
  .tp-discord-section {
    padding: 7rem 1.5rem;
    position: relative;
    overflow: hidden;
    contain: layout style;
  }
  .tp-discord-section::before {
    content: '';
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 75% 55% at 50% 0%, rgba(88,101,242,.08) 0%, transparent 65%),
      radial-gradient(ellipse 45% 45% at 82% 100%, rgba(114,137,218,.055) 0%, transparent 60%);
    pointer-events: none;
  }
  .tp-discord-grid {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5rem;
    align-items: center;
  }
  .tp-discord-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: .68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .16em;
    color: var(--tp-discord);
    margin-bottom: 1.25rem;
  }
  .tp-discord-label-dot {
    width: 8px; height: 8px;
    background: var(--tp-discord);
    border-radius: 50%;
    box-shadow: 0 0 12px var(--tp-discord);
    animation: tp-pulse-dot 1.6s ease-in-out infinite;
  }
  .tp-discord-h2 {
    font-family: var(--tp-display);
    font-size: clamp(2.4rem, 5.5vw, 3.75rem);
    font-weight: 700;
    letter-spacing: -.04em;
    line-height: 1.04;
    color: var(--tp-t1);
    margin: 0 0 1.25rem;
  }
  .tp-discord-h2 em {
    font-style: normal;
    background: linear-gradient(135deg, var(--tp-discord), var(--tp-discord2));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .tp-discord-sub { font-size: 1.055rem; color: var(--tp-t2); line-height: 1.85; margin-bottom: 2rem; }
  .tp-discord-stats-row { display: flex; gap: 2.25rem; margin-bottom: 2.5rem; flex-wrap: wrap; }
  .tp-discord-stat { display: flex; flex-direction: column; gap: 4px; }
  .tp-discord-stat-n {
    font-family: var(--tp-display);
    font-size: 2.1rem; font-weight: 700;
    color: var(--tp-t1);
    letter-spacing: -.04em; line-height: 1;
  }
  .tp-discord-stat-n span { color: var(--tp-discord); }
  .tp-discord-stat-l {
    font-size: .68rem; color: var(--tp-t3);
    text-transform: uppercase; letter-spacing: .12em; font-weight: 700;
  }

  .tp-discord-actions {
    display: flex;
    flex-direction: column;
    gap: .75rem;
    align-items: flex-start;
  }
  .tp-discord-actions-row {
    display: flex;
    gap: .875rem;
    flex-wrap: wrap;
    align-items: center;
  }
  .tp-discord-join-note {
    font-size: .72rem;
    color: var(--tp-t3);
    display: flex;
    align-items: center;
    gap: 5px;
  }

  /* Discord server card */
  .tp-discord-card {
    background: var(--tp-surface);
    border: 1px solid rgba(88,101,242,.22);
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 32px 64px rgba(0,0,0,.45), 0 0 0 1px rgba(88,101,242,.06);
    animation: tp-slide-in-right .7s .15s both;
    transition: transform .3s cubic-bezier(.16,1,.3,1), box-shadow .3s;
    will-change: transform;
  }
  .tp-discord-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 40px 80px rgba(0,0,0,.5), 0 0 40px rgba(88,101,242,.1);
  }
  .tp-discord-card-banner {
    height: 100px;
    background: linear-gradient(135deg, #23272a 0%, #1a1d2e 50%, #2c1f6e 100%);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tp-discord-card-banner::before {
    content: '';
    position: absolute; inset: 0;
    background: radial-gradient(circle at 70% 50%, rgba(88,101,242,.35) 0%, transparent 60%);
  }
  .tp-discord-card-banner::after {
    content: '';
    position: absolute;
    top: 0; left: -80%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,.06), transparent);
    transform: skewX(-15deg);
    animation: tp-shimmer-bar 4s ease-in-out infinite;
    will-change: left;
  }
  .tp-discord-logo-watermark {
    color: rgba(88,101,242,.18);
    z-index: 0;
  }
  .tp-dc-avatar-row {
    padding: 0 1.25rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: -20px;
    margin-bottom: .875rem;
  }
  .tp-dc-avatar {
    width: 58px; height: 58px;
    border-radius: 50%;
    border: 4px solid var(--tp-surface);
    background: linear-gradient(135deg, #23272a, #1a1d2e);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    position: relative; z-index: 1;
  }
  .tp-dc-online-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: rgba(15,214,138,.1);
    border: 1px solid rgba(15,214,138,.22);
    border-radius: 100px;
    font-size: .72rem;
    color: var(--tp-green);
    font-weight: 700;
  }
  .tp-dc-online-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: var(--tp-green);
    box-shadow: 0 0 8px var(--tp-green);
    animation: tp-pulse-dot 1.6s infinite;
  }
  .tp-dc-body { padding: 0 1.25rem 1.5rem; }
  .tp-dc-name {
    font-family: var(--tp-display);
    font-size: 1.15rem; font-weight: 700;
    color: var(--tp-t1); letter-spacing: -.02em;
    margin-bottom: .375rem;
  }
  .tp-dc-desc { font-size: .82rem; color: var(--tp-t2); line-height: 1.65; margin-bottom: 1.125rem; }
  .tp-dc-members-row {
    display: flex; align-items: center;
    gap: .875rem; margin-bottom: 1.25rem;
  }
  .tp-dc-member-avatars { display: flex; }
  .tp-dc-member-avatar {
    width: 30px; height: 30px;
    border-radius: 50%;
    border: 2px solid var(--tp-surface);
    margin-left: -8px;
    font-size: .85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .tp-dc-member-avatar:first-child { margin-left: 0; }
  .tp-dc-member-more {
    background: rgba(88,101,242,.14);
    border-color: rgba(88,101,242,.2);
    font-size: .6rem;
    font-weight: 700;
    color: var(--tp-discord);
  }
  .tp-dc-members-text { font-size: .8rem; color: var(--tp-t2); }
  .tp-dc-members-text strong { color: var(--tp-t1); }
  .tp-dc-channels {
    background: var(--tp-surface2);
    border: 1px solid var(--tp-line);
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1.25rem;
  }
  .tp-dc-channel-header {
    padding: .45rem 1rem;
    font-size: .6rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .14em;
    color: var(--tp-t3);
    border-bottom: 1px solid var(--tp-line);
  }
  .tp-dc-channel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .45rem 1rem;
    font-size: .78rem;
    color: var(--tp-t2);
    transition: background .15s, color .15s;
    cursor: default;
  }
  .tp-dc-channel:hover { background: rgba(77,127,255,.04); color: var(--tp-t1); }
  .tp-dc-channel-left { display: flex; align-items: center; gap: 7px; }
  .tp-dc-channel-icon { color: var(--tp-t3); font-size: .88rem; }
  .tp-dc-channel-badge {
    font-size: .62rem;
    padding: 1px 7px;
    background: var(--tp-discord);
    border-radius: 100px;
    color: #fff;
    font-weight: 700;
  }
  .tp-discord-tags {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    margin-top: 1.75rem;
  }
  .tp-discord-tag {
    padding: 4px 11px;
    background: rgba(88,101,242,.07);
    border: 1px solid rgba(88,101,242,.17);
    border-radius: 100px;
    font-size: .68rem;
    font-weight: 700;
    color: var(--tp-discord2);
    letter-spacing: .04em;
  }

  @media (max-width: 900px) {
    .tp-discord-grid { grid-template-columns: 1fr; gap: 3rem; }
  }
  @media (max-width: 640px) {
    .tp-discord-stats-row { flex-direction: column; gap: 1.5rem; }
    .tp-discord-section   { padding: 4rem 1rem; }
  }
`;

export default function TrainingDiscord({ scrollToPayment }) {
  return (
    <section className="tp-discord-section">
      <div className="tp-discord-grid tp-container">
        {/* Left: Copy */}
        <div style={{ animation: "tp-slide-in-left .7s .1s both" }}>
          <div className="tp-discord-label">
            <span className="tp-discord-label-dot" />
            Community
          </div>
          <h2 className="tp-discord-h2">
            Pakistan's <em>Largest</em>
            <br />
            Open Source
            <br />
            Community
          </h2>
          <p className="tp-discord-sub">
            QuantumLogics isn't just a company — it's a movement. We've built
            Pakistan's most active tech community with the strongest Discord
            presence in the country. 10,000+ developers collaborating, shipping,
            and growing together.
          </p>

          <div className="tp-discord-stats-row">
            {[
              ["10K+", "Community Members"],
              ["#1", "Discord in Pakistan"],
              ["50+", "OSS Projects"],
            ].map(([n, l]) => (
              <div key={l} className="tp-discord-stat">
                <div className="tp-discord-stat-n"><span>{n}</span></div>
                <div className="tp-discord-stat-l">{l}</div>
              </div>
            ))}
          </div>

          <div className="tp-discord-actions">
            <div className="tp-discord-actions-row">
              <button className="tp-btn-primary" onClick={scrollToPayment}>
                Enroll in Training
                <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
              <a
                href="https://discord.gg/qCvxh7ZhSv"
                target="_blank"
                rel="noopener noreferrer"
                className="tp-btn-discord"
              >
                <DiscordIcon size={16} />
                Join Discord
              </a>
            </div>
            <div className="tp-discord-join-note">
              <span style={{ color: "var(--tp-t3)" }}>Discord is free · No enrollment required</span>
            </div>
          </div>

          <div className="tp-discord-tags">
            {["Open Source", "Mentorship", "Job Board", "Code Reviews", "Networking", "Hackathons"].map((tag) => (
              <span key={tag} className="tp-discord-tag">{tag}</span>
            ))}
          </div>
        </div>

        {/* Right: Discord card mockup */}
        <div>
          <div className="tp-discord-card">
            <div className="tp-discord-card-banner">
              <div className="tp-discord-logo-watermark">
                <DiscordIcon size={68} />
              </div>
            </div>
            <div className="tp-dc-avatar-row">
              <div className="tp-dc-avatar">
                <img src="logo512.png" alt="logo.png" />
              </div>
              <div className="tp-dc-online-badge">
                <span className="tp-dc-online-dot" />
                1,240 Online Now
              </div>
            </div>
            <div className="tp-dc-body">
              <div className="tp-dc-name">QuantumLogics Community</div>
              <div className="tp-dc-desc">
                Pakistan's #1 open source community. 10,000+ developers building
                the future together.
              </div>
              <div className="tp-dc-members-row">
                <div className="tp-dc-member-avatars">
                  {["👨‍💻","👩‍💻","🧑‍💻","👨‍🔬"].map((e, i) => (
                    <div key={i} className="tp-dc-member-avatar" style={{ background: `hsl(${i * 50 + 215},55%,16%)` }}>
                      {e}
                    </div>
                  ))}
                  <div className="tp-dc-member-avatar tp-dc-member-more">+9K</div>
                </div>
                <div className="tp-dc-members-text"><strong>10,000+</strong> members</div>
              </div>
              <div className="tp-dc-channels">
                <div className="tp-dc-channel-header">Text Channels</div>
                {DISCORD_CHANNELS.map((ch) => (
                  <div key={ch.name} className="tp-dc-channel">
                    <div className="tp-dc-channel-left">
                      <span className="tp-dc-channel-icon">#</span>
                      {ch.name}
                    </div>
                    {ch.badge && <span className="tp-dc-channel-badge">{ch.badge}</span>}
                  </div>
                ))}
              </div>
              <a
                href="https://discord.gg/qCvxh7ZhSv"
                target="_blank"
                rel="noopener noreferrer"
                className="tp-btn-discord"
                style={{ width: "100%", justifyContent: "center" }}
              >
                <DiscordIcon size={16} />
                Join the Server — Free
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
